import { render, staticRenderFns } from "./activity_add.vue?vue&type=template&id=5e8a5c70&scoped=true&"
import script from "./activity_add.vue?vue&type=script&lang=js&"
export * from "./activity_add.vue?vue&type=script&lang=js&"
import style0 from "./activity_add.vue?vue&type=style&index=0&id=5e8a5c70&lang=less&scoped=true&"
import style1 from "./activity_add.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a5c70",
  null
  
)

export default component.exports